import Background from "./background";

export default function SwipePage({ children }) {
  return (
    <div className="page page--swipe swipe__page">
      <Background />
      {children}
    </div>
  );
}
